module.exports = __webpack_public_path__ + "static/media/c6bannerModul3_small.5befb5cd.jpg";